import type { TextInputProps } from 'react-native';

type PasswordAutofillProps = Pick<TextInputProps, 'textContentType' | 'autoComplete'>;

/**
 * Autofill-props voor wachtwoordvelden.
 */
export function getPasswordAutofillProps(): PasswordAutofillProps {
	if (__DEV__) {
		return { textContentType: 'oneTimeCode', autoComplete: 'off' };
	}

	return {};
}
